define.alias("shared/components/shared/ui/education", "preview-grid/components/shared/ui/education");